import React, {useEffect, useRef, useState} from "react";
import {AutoSizer, List} from "react-virtualized";
import {
    Avatar,
    Button,
    ListItem as MListItem,
    ListItemAvatar,
    ListItemText,
    makeStyles,
    Tooltip,
    useMediaQuery
} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {
    clearOrderedAssays,
    setAssayLine,
    setAssayTime,
    setListOfPatients,
    setOrderNote,
    setTurnBack
} from "@cabinet-packages/redux";
import {useAssaysFilter} from "@cabinet-packages/hooks";
import {useHistory} from "react-router";
import {ConfirmPayment, CustomDialog, ListItem, Loading,} from "@cabinet-packages/components";
import TextField from "@material-ui/core/TextField";
import GroupIcon from "@material-ui/icons/Group";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {setCreateOrder} from "@cabinet-packages/api/api";
import {setOrderId} from "@cabinet-packages/redux/actions/actionsCreators";
import AddIcon from "@material-ui/icons/Add";
import {AddNewPatient} from "@cabinet-packages/pages";
import {AccessKey} from "@cabinet-packages/helpers";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    rootScrollWrapper: {
        width: '100%',
        maxWidth: '900px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        maxHeight: "calc(100dvh - 80px)",
        height: "max-content",
        minHeight: "100dvh",
    },
    openAddNewPatient: {
        height: 'max-content',
        transition: '1s',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        background: 'rgba(0, 0, 0, 0.05)',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        padding: '0px 8px 8px 8px',
    },
    closeAddNewPatient: {
        height: '0px',
        transition: '1s',
        overflow: 'hidden',
        display: 'none',
    },
    root: {
        width: '100%',
        maxWidth: '900px',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: '272px 100px 30px 60px auto 47px',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        margin: '0 auto',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        maxHeight: "calc(100vh - 50px)",
        overflowY: "auto",

        '@media (max-width: 900px)': {
            gridTemplateRows: '255px 66px 60px auto auto 120px',
        },
    },
    detailsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '5px',
        '@media (max-width: 900px)': {
            flexDirection: 'column',
            justifyContent: 'center',
            padding: ' 5px 0',
        },
    },
    orderInfoTextWrapper: {
        height: '90px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    orderInfoText: {
        fontSize: '1.17rem',
        border: `1px solid ${theme.palette.primary.main}`,
        padding: '8px',
        maxWidth: '100%',
        width: '100%',
        textAlign: 'center',
        alignSelf: 'center',
        '@media (max-width: 1140px)': {
            fontSize: '1rem',
        },
    },
    detailsOrder: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        '@media (max-width: 900px)': {
            margin: '0',
            maxWidth: '100%',
            width: 'inherit',
        },
    },
    detailsItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        marginBottom: '2px',
        padding: '5px',
    },
    detailsItemHeader: {
        fontWeight: 500,
        color: theme.palette.primary.dark,
    },
    detailsItemText: {
        fontWeight: 500,
    },
    detailsItemTextPrice: {
        fontWeight: 500,
        color: theme.palette.error.light,
    },
    searchFieldContainer: {
        marginTop: '10px',
        padding: '0 10px 0 10px',
        '@media (max-width: 900px)': {
            display: 'none',
        },
    },
    searchField: {
        margin: 0,
    },
    list: {
        '&:focus': {
            outline: 'none',
        },
    },
    listItemBottom: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '40px',
        padding: '12px 0',
    },
    totalPriceContainer: {
        padding: '10px 10px',
        fontSize: '18px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    },
    actionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    noAssays: {
        margin: '20px 0px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    actionButton: {
        margin: '10px',
    },
    headerOfOrderedAssays: {
        padding: '5px',
        borderTop: '1px solid rgba(0, 0, 0, 0.3)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        fontWeight: 500,
        color: theme.palette.primary.dark,
        '@media (max-width: 900px)': {
            display: 'none',
        },
    },
    bottomContainer: {
        background: 'white',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        position: 'relative',
        paddingBottom: '5px',
        '@media (max-width: 900px)': {
            position: 'sticky',
            bottom: 0,
            left: 0,
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
    },
    buttonConfirmOrder: {
        maxWidth: 200,
        maxHeight: '40px',
        width: '100%',
        boxSizing: 'border-box',
        margin: '0 auto',
        marginTop: '5px',
    },
    buttonLink: {
        padding: '0',
    },
    redButton: {
        color: '#e41e15',
        maxWidth: 200,
        maxHeight: '40px',
        width: '100%',
        boxSizing: 'border-box',
        margin: '0 auto',
        marginTop: '5px',

        '@media (max-width: 1140px)': {
            width: '95%',
            margin: '4px auto',
        },
    },
    commentaryWrapper: {
        width: '100%',
        padding: '10px',
        '@media (max-width: 900px)': {
            padding: '5px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        },
    },
    commentaryHeader: {
        fontWeight: 500,
        color: theme.palette.primary.dark,
        marginBottom: '5px',
        '@media (max-width: 900px)': {
            display: 'none',
        },
    },
    commentary: {
        width: '100%',
        height: '100%',
    },
    listWrapper: {
        listStyle: 'none',
        width: '100%',
    },
    listItem: {
        display: 'grid',
        gridTemplateColumns: '55% 15% 15% 15%',
        textAlign: 'center',
        boxSizing: 'border-box',

        '@media (max-width: 1140px)': {
            gridTemplateColumns: '55% 15% 30%',
        },
    },
    listItemTitle: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        fontSize: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '5px',
        textAlign: 'start',
        cursor: 'pointer',
        boxSizing: 'border-box',

        '@media (max-width: 1140px)': {
            fontSize: '14px',
            wordBreak: 'break-all',
        },
    },
    listItemTitleForTake: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        height: 'inherit',
        fontSize: '16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '5px',
        textAlign: 'start',
        boxSizing: 'border-box',

        '@media (max-width: 1140px)': {
            fontSize: '14px',
            wordBreak: 'break-all',
        },
    },
    listItemGroupTitle: {
        fontSize: '16px',
        letterSpacing: '1px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        height: '100%',
        padding: '5px',
        '@media (max-width: 1140px)': {
            padding: '5px 5px 5px 5%',
        },
    },
    listItemTime: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '5px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        '@media (max-width: 1140px)': {
            display: 'none',
        },
    },
    listItemPrice: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        display: 'flex',
        userSelect: 'none',
        padding: '5px',
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
    listItemPriceWithDiscount: {
        borderLeft: '2px solid rgba(0, 0, 0, 0.1)',
        padding: '5px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',

        '@media (max-width: 1140px)': {
            lineHeight: '100%',
        },
    },
    listItemPriceNumber: {
        alignSelf: 'center',
        color: theme.palette.error.main,
    },
    listItemHeaderOfGroup: {
        background: theme.palette.primary.main,
        color: 'rgb(70, 70, 70)',
    },
    addRemoveButton: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    listHeadersContainer: {
        background: theme.palette.primary.main,
        display: 'grid',
        gridTemplateColumns: '55% 15% 15% 15%',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxSizing: 'border-box',
        overflow: 'hidden',
        width: '100%',

        '@media (max-width: 1140px)': {
            gridTemplateColumns: '55% 15% 30%',

            '& :nth-child(2)': {
                display: 'none',
            },
        },
    },
    listHeader: {
        fontSize: '15px',
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',

        "&:last-child": {
            borderRight: 'none',
        },
    },
    listHeaderAssayName: {
        fontSize: '15px',
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
        paddingLeft: '8px',

        "&:last-child": {
            borderRight: 'none',
        },
    },
    listHeaderRedDiscount: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: '24px',
        color: 'white',
        background: theme.palette.error.light,
        border: `2px solid ${theme.palette.error.main}`,
        borderRadius: '16px',
        width: '32px',
        height: '32px',
        position: 'absolute',
        top: 3,
        right: 0,
    },
    listHeaderTinyText: {
        fontSize: '10px',
    },
    listForComplexFillings: {
        listStylePosition: 'inside',
    },
    complexFillings: {
        fontSize: '13px',
        color: 'rgba(0, 0, 0, 0.6)',
    },
    loading: {
        minHeight: '100vh',
    },
}))

const ConfirmOrder = ({isComponentInShop}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const {catalog, complexResearch, actions, takeId}  = useSelector(state => state.assaysCatalog);
    const {activePatient, listOfPatients}  = useSelector(state => state.patients);
    const { orderingList, amountOfItems, totalPrice, selectedPunkt, time, timeLine, note, orderId, promoCode } = useSelector(state => state.orderAssays);
    const {themeMaterialUI} = useSelector(store => store.theme);
    const previousAmountOfItems = useRef();
    const [value, setValue] = useState('');
    const [loading] = useState(false);
    const listRef = useRef();
    const [anchorEl, setAnchorEl] = useState(null);
    const media = useMediaQuery('(max-width: 1140px)');
    const [openAddNewPatient, setOpenAddNewPatient] = useState(false);
    const [goToPayment, setGoToPayment] = useState(false);

    const handleOpenAddNewPatient = (event) => {
        event.stopPropagation();
        event.preventDefault();

        setOpenAddNewPatient(prev => !prev);
        if (anchorEl) setAnchorEl(null);
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const createAssaysData = (ids) => catalog && complexResearch && actions && ids.map(currId => (
        [...catalog, ...complexResearch, ...actions].find(currAssay => +currAssay.id === +currId.id && currAssay.type === currId.type)));

    const handleConfirm = async ()  => {
        const timeForSend = timeLine
            ? `${timeLine} 00:00:00.0000`
            : time ? `${time}:00.0000` : moment().clone().add(1, 'day');
        const services = createAssaysData(orderingList).map(item => {
            if (item.type === 'action') {

                return complexResearch.find(com => com.code === item.code);
            }

            return item;
        }).map(item => {

            if (promoCode && promoCode.type !== 'none') {
                if (promoCode.type === 'all') {
                    if (item.idParent !== takeId) {
                        return ({
                            idPacket: item.id,
                            idConf: item.idConf,
                            price: item.price,
                            packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                            priceDiscount: Math.ceil(+item.price - (+item.price * (+promoCode.discount/100))),
                            discount: Math.floor((+item.price * (+promoCode.discount/100))),
                            amount: 1,
                            debt: 0,
                            durationDay: item.duration_day ? item.duration_day : 1,
                        });
                    } else {
                        return ({
                            idPacket: item.id,
                            idConf: item.idConf,
                            price: item.price,
                            packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                            priceDiscount: item.discount ? Math.ceil(item.price - item.price * item.discount / 100) : item.price,
                            discount: item.discount ? Math.floor( item.price * item.discount / 100) : 0,
                            amount: 1,
                            debt: 0,
                            durationDay: item.duration_day ? item.duration_day : 1,
                        });
                    }
                } else if (promoCode.type === 'specified') {
                    if (item.idParent !== takeId) {
                        const foundDiscount = promoCode.grtests.find(it => +it[0] === +item.id);

                        if (foundDiscount) {
                            return ({
                                idPacket: item.id,
                                idConf: item.idConf,
                                price: item.price,
                                packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                                priceDiscount: +foundDiscount[1] === 0 ? +foundDiscount[2] : Math.ceil(+item.price - (+item.price * (+foundDiscount[1]/100))),
                                discount: +foundDiscount[1] === 0 ? (+item.price)-(+foundDiscount[2]) : Math.floor((+item.price * (+foundDiscount[1]/100))),
                                amount: 1,
                                debt: 0,
                                durationDay: item.duration_day ? item.duration_day : 1,
                            });
                        } else {
                            return ({
                                idPacket: item.id,
                                idConf: item.idConf,
                                price: item.price,
                                packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                                priceDiscount: item.discount ? Math.ceil(item.price - item.price * item.discount / 100) : item.price,
                                discount: item.discount ? Math.floor(item.price * item.discount / 100) : 0,
                                amount: 1,
                                debt: 0,
                                durationDay: item.duration_day ? item.duration_day : 1,
                            });
                        }
                    } else {
                        return ({
                            idPacket: item.id,
                            idConf: item.idConf,
                            price: item.price,
                            packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                            priceDiscount: item.discount ? Math.ceil(item.price - item.price * item.discount / 100) : item.price,
                            discount: item.discount ? Math.floor(item.price * item.discount / 100) : 0,
                            amount: 1,
                            debt: 0,
                            durationDay: item.duration_day ? item.duration_day : 1,
                        })
                    }
                } else if (promoCode.type === 'notdisc') {
                    if (item.idParent !== takeId) {
                        const discount = item.opt && item.opt.includes(promoCode.type) ? item.discount : promoCode.discount;

                        return ({
                            idPacket: item.id,
                            idConf: item.idConf,
                            price: item.price,
                            packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                            priceDiscount: Math.ceil(+item.price - (+item.price * (+discount/100))),
                            discount: Math.floor((+item.price * (+discount/100))),
                            amount: 1,
                            debt: 0,
                            durationDay: item.duration_day ? item.duration_day : 1,
                        });
                    } else {
                        return ({
                            idPacket: item.id,
                            idConf: item.idConf,
                            price: item.price,
                            packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                            priceDiscount: item.discount ? Math.ceil(item.price - item.price * item.discount / 100) : item.price,
                            discount: item.discount ? Math.floor(item.price * item.discount / 100) : 0,
                            amount: 1,
                            debt: 0,
                            durationDay: item.duration_day ? item.duration_day : 1,
                        });
                    }
                }
            } else {
                return ({
                    idPacket: item.id,
                    idConf: item.idConf,
                    price: item.price,
                    packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                    priceDiscount: item.discount ? Math.ceil(item.price - item.price * item.discount / 100) : item.price,
                    discount: item.discount ? Math.floor(item.price * item.discount / 100) : 0,
                    amount: 1,
                    debt: 0,
                    durationDay: item.duration_day ? item.duration_day : 1,
                });
            }
        });

        try {
            const result = await setCreateOrder(
                selectedPunkt?.idPunkt,
                value,
                `${activePatient.lastname} ${activePatient.firstname} ${activePatient.fathername}`,
                activePatient?.id,
                orderId,
                timeForSend,
                services.reduce((acu, cur) =>{
                    return acu + cur.price;
                }, 0),
                totalPrice,
                'card',
                promoCode ? promoCode.code : 'none',
                services);

            dispatch(setOrderId(result));

            const items = createAssaysData(orderingList).map(item => {
                if (item.type === 'action') {

                    return complexResearch.find(com => com.code === item.code);
                }

                return item;
            }).map(item => ({
                id: item.id,
                name: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
                variant: item.type,
                price: item.discount
                    ? Math.ceil(item.price - item.price * item.discount / 100)
                    : item.price,
                quantity: 1,
            }));

            // window.dataLayer.push({
            //     event: 'purchase',
            //     eventProps: {
            //         items,
            //         transaction_id: result,
            //     },
            //     coupon: '',
            // });
            dispatch(clearOrderedAssays())
        } catch (error) {
            console.error(error)
            if (error?.response?.status === 401) {
                localStorage.removeItem('activePatient');
                localStorage.removeItem('accessKey');
                localStorage.removeItem('activePatientPhone');
                localStorage.removeItem('uuid');
                AccessKey.remove();
                history.push('/');
                window.location.reload();
            }
        }

        isComponentInShop
            ? history.push('/shop-portmone-payment')
            : history.push('/portmone-payment');
    };

    const handleSendOrdering = () => {
        CustomDialog(ConfirmPayment, {
            text: `Вартість даного замовлення ${totalPrice} грн.`,
            onConfirm: () => {
                setGoToPayment(true)
            },
        }, false, themeMaterialUI);
    };

    useEffect(() => {
        if (goToPayment) {
            handleConfirm();
            setGoToPayment(false);
        }
    }, [goToPayment]);

    // const handleSendOrderingWithoutPayment = () => {
    //     const handleConfirm = async ()  => {
    //         setLoading(true);
    //         const timeForSend = timeLine ? `${timeLine} 00:00:00.0000` : `${time}:00.0000`;
    //         const services = createAssaysData(orderingList).map(item => ({
    //             idPacket: item.id,
    //             idConf: item.idConf,
    //             price: item.price,
    //             packetName: item.name ? item.name : item.testNames.split(',')[0].split('\\\\').join(''),
    //             priceDiscount: item.discount ? item.price - item.price * item.discount / 100 : item.price,
    //             discount: item.discount ? item.discount : 0,
    //             amount: 1,
    //             debt: 0,
    //             durationDay: item.duration_day ? item.duration_day : 1,
    //         }));
    //
    //         const result = await setCreateOrder(
    //             selectedPunkt.idPunkt,
    //             value,
    //             `${activePatient.lastname} ${activePatient.firstname} ${activePatient.fathername}`,
    //             activePatient.id,
    //             orderId,
    //             timeForSend,
    //             services.reduce((acu, cur) =>{
    //                 return acu + cur.price;
    //             }, 0),
    //             totalPrice,
    //             'cash',
    //             promoCode ? promoCode.code : 'none',
    //             services,
    //             'reserved').catch((e) => 'error');
    //
    //         if (result && result !== 'error') {
    //             dispatch(setOrderId(result));
    //             CustomDialog(TextAlertDialog,{text: "Ваше замовлення успішно створене."}, false, themeMaterialUI);
    //         } else if (result === 'error') {
    //             CustomDialog(TextAlertDialog,{text: "Вибачте, сталась помилка при створенні замовлення. Спробуйте повторити пізніше."}, false, themeMaterialUI);
    //         }
    //         setLoading(false);
    //     };
    //     CustomDialog(ConfirmPayment, {
    //         text: `Вартість даного замовлення ${totalPrice} грн. Оплатіть замовлення при відвідуванні пункту забору.`,
    //         textButton: 'Створити замовлення',
    //         onConfirm: handleConfirm,
    //     }, false, themeMaterialUI);
    // };

    const handleInputValue = (value) => {
        setValue(value);
        dispatch(setOrderNote(value));
    };

    const handleClickOnIconButton = (path) => {
        history.push(path);
        dispatch(setTurnBack(true));
        dispatch(setAssayLine());
        dispatch(setAssayTime());
    };

    const handleReturnToDatePick =  () => {
        isComponentInShop
            ? history.push('/shop-assay-scheduler-time')
            : history.push('/assay-scheduler-time');
        dispatch(setAssayLine());
        dispatch(setAssayTime());
    };

    // const handleTransitionToAdditionalOrder = () => {
    //     isComponentInShop
    //         ? takeId === 14 ? history.push('/shop') : history.push('/shop-catalog')
    //         : history.push('/catalog-table');
    // };

    const handleGoBack = (event) => {
        event.stopPropagation();
        event.preventDefault();

        isComponentInShop
            ? history.push('/shop')
            : history.push('/catalog-table');
    };

    const {
        backToInitialState,
        filteredState,
    } = useAssaysFilter(createAssaysData(orderingList), true);

    function rowRenderer(props) {
        const { index, style, key } = props;
        const item = filteredState[index];

        const newStyles = {
            ...style,
            background: index%2 === 0 ? 'none': 'rgba(0, 0, 0, 0.05)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        };

        const handleClickOnAssay = (event, isTake) => {
            event.stopPropagation();
            event.preventDefault();

            switch (item.type) {
                case "action": {
                    isComponentInShop
                        ? history.push(`/shop-actions-details/${item.id}`)
                        : history.push(`/actions-details/${item.id}`)
                    break;
                }
                case "complex": {
                    isComponentInShop
                        ? history.push(`/shop-complex-info/${item.id}`)
                        : history.push(`/complex-info/${item.id}`)
                    break;
                }
                case "assay": {
                    isComponentInShop
                        ? !isTake && history.push(`/shop-assay-info/${item.id}`)
                        : !isTake && history.push(`/assay-info/${item.id}`)
                    break;
                }
                default: {
                    return;
                }
            }
        }

        return (
            <div
                className={classes.listItem}
                style={{
                    ...newStyles,
                    textDecoration: 'none',
                    color: 'inherit',
                }}
                key={key}
            >
                <div
                    className={item.idParent === 14 ? classes.listItemTitleForTake : classes.listItemTitle}
                    onClick={event => handleClickOnAssay(event, item.idParent === 14)}
                >
                    <p>
                        {item.name
                            ? takeId === 14 ? item.name : item.name.split(')')[0] + (item.name.indexOf('(') >= 0 ? ') ' : ' ')
                            : item.testNames.split(',')[0].split('\\\\').join('')
                        }
                    </p>
                    {item.type === 'complex' && <ol className={classes.listForComplexFillings}>
                        {[...item.filling, ...item.idGrTest].map((fill, idx) => (<li
                            key={fill.id + ' ' + idx}
                            className={classes.complexFillings}
                        >
                            {fill.name}
                        </li>))}
                    </ol>
                    }
                </div>
                <div className={classes.listItemTime}>
                    {item.duration_day}
                </div>
                <div className={classes.listItemPrice}>
                    {item.price && +item.price}
                </div>
                <div className={classes.listItemPriceWithDiscount}>
                    <div className={classes.listItemPriceNumber}>
                        {item.discount
                            ? Math.ceil(item.price && (item.price - item.price * item.discount / 100))
                            : item.price && item.price
                        }
                    </div>
                </div>
            </div>
        );
    }

    const getAssayRowHeight = (index, width) => {
        const name = filteredState[index].name
            ? takeId === 14 ? filteredState[index].name : (filteredState[index].name.split(')')[0] + (filteredState[index].name.indexOf('(') >= 0 ? ') ' : ' '))
            : (filteredState[index].testNames.split(',')[0].split('\\\\').join(''));

        if (filteredState[index].superGroupName) return 50;

        const symbolWidth = 16;
        const lineHeight = 14;
        const result = Math.ceil((name.length*symbolWidth)/(width/2)) * lineHeight;
        const fillingNameLength = width > 800 ? 60 : width > 600 ? 40  : width > 500 ? 35 : width > 400 ? 30 : 25;

        return result > 50
            ? filteredState[index].type === "complex"
                ? +result + ([...filteredState[index].filling, ...filteredState[index].idGrTest].reduce((acu, cur) => {
                if (cur.name.length > fillingNameLength) return acu + Math.ceil(cur.name.length/fillingNameLength);
                return acu + 1;
            }, 0) * 17)
                : result
            : filteredState[index].type === "complex"
                ? 50 + ([...filteredState[index].filling, ...filteredState[index].idGrTest].reduce((acu, cur) => {
                if (cur.name.length > fillingNameLength) return acu + Math.ceil(cur.name.length/fillingNameLength);
                return acu + 1;
            }, 0) * 17)
                : 50
    };

    useEffect(() => {
        if (previousAmountOfItems.current !== amountOfItems) {
            backToInitialState();
            previousAmountOfItems.current = amountOfItems;
        }
        if (!value && note) setValue(note)

        dispatch(setListOfPatients());
    }, [amountOfItems, value, note,  dispatch, listOfPatients, backToInitialState]);

    return (catalog && complexResearch && actions && !loading
        ? <div className={classes.rootScrollWrapper}>
            {openAddNewPatient && <div className={openAddNewPatient ? classes.openAddNewPatient : classes.closeAddNewPatient}>
                <AddNewPatient isInDialog={true}/>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenAddNewPatient}
                >
                    приховати форму
                </Button>
            </div>}
            <div className={classes.root}>
                <div className={classes.detailsWrapper}>
                    <div className={classes.orderInfoTextWrapper}>
                        <div className={classes.orderInfoText}>
                            УВАГА! Усі обрані дослідження необхідно здати під час одного візиту.
                        </div>
                    </div>
                    <div className={classes.detailsOrder}>
                        <div className={classes.detailsItem}>
                            <div>
                                <h4 className={classes.detailsItemHeader}>ПІБ пацієнта:</h4>
                                <p className={classes.detailsItemText}>{activePatient && `${activePatient.lastname} ${activePatient.firstname} ${activePatient.fathername}`}</p>
                            </div>
                            <Tooltip
                                title="Натисніть щоб змінити пацієнта."
                                arrow
                            >
                                <Button
                                    color="primary"
                                    className={classes.buttonLink}
                                    onClick={handleClick}
                                >
                                    <GroupIcon color="inherit"/>
                                </Button>
                            </Tooltip>
                            <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                {listOfPatients && listOfPatients !== 'Unauthorized' && listOfPatients !== 'error' && listOfPatients.map(patient => (
                                    <MenuItem onClick={handleClose} key={patient.id}>
                                        <ul className={classes.listWrapper}>
                                            {activePatient && <ListItem patient={patient} isSelected={activePatient.id === patient.id} inConfirmOrder={true}/>}
                                        </ul>
                                    </MenuItem>
                                ))}
                                <MenuItem onClick={handleOpenAddNewPatient}>
                                    <ul className={classes.listWrapper}>
                                        <MListItem divider button>
                                            <ListItemAvatar>
                                                <Avatar
                                                    className={classes.avatar}
                                                >
                                                    <AddIcon/>
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={"Додати нового пацієнта."}
                                            />
                                        </MListItem>
                                    </ul>
                                </MenuItem>
                            </Menu>
                        </div>
                        <div className={classes.detailsItem}>
                            <div>
                                <h4 className={classes.detailsItemHeader}>Адреса пункту забору:</h4>
                                <p className={classes.detailsItemText}>{selectedPunkt ? selectedPunkt.address : 'Виберіть пункт забору!'}</p>
                            </div>
                            <Tooltip
                                title="Натисніть щоб змінити пункт забору."
                                arrow
                            >
                                <Button
                                    color="primary"
                                    className={classes.buttonLink}
                                    onClick={() => handleClickOnIconButton('/order-collection-points')}
                                >
                                    <LocationOnIcon color="inherit"/>
                                </Button>
                            </Tooltip>
                        </div>
                        <div className={classes.detailsItem}>
                            <h4 className={classes.detailsItemHeader}>Загальна вартість:</h4>
                            <p className={classes.detailsItemTextPrice}>{totalPrice} грн</p>
                        </div>
                    </div>
                </div>

                <div className={classes.commentaryWrapper}>
                    <h4 className={classes.commentaryHeader}>Коментар до поточного замовлення:</h4>
                    <TextField
                        label="Залиште коментар тут"
                        multiline={true}
                        rows={1}
                        className={classes.commentary}
                        variant="outlined"
                        onChange={(event) => handleInputValue(event.target.value)}
                        value={value}
                    />
                </div>
                <h4 className={classes.headerOfOrderedAssays}>Список замовлених досліджень:</h4>
                <div
                    className={classes.listHeadersContainer}
                    style={{
                        paddingRight: amountOfItems > 9 && !media && '17px',
                    }}
                >
                    <div className={classes.listHeaderAssayName}>
                        <p>
                            Назва дослідження
                        </p>
                    </div>
                    <div className={classes.listHeader}>
                        <p>
                            Термін виконання,
                            <span className={classes.listHeaderTinyText}> робочих днів</span>
                        </p>
                    </div>
                    <div className={classes.listHeader}>
                        <p>
                            Ціна, грн
                        </p>
                    </div>
                    <div className={classes.listHeader}>
                        <p>
                            Ціна <br/> он-лайн, <br/> грн
                        </p>
                        <span className={classes.listHeaderRedDiscount}>%</span>
                    </div>
                </div>
                {amountOfItems > 0
                    ? (<div style={{
                        height: 'max-content',
                        width: '100%',
                        minHeight: amountOfItems > 6 ? '450px' : '250px',
                    }}>
                        <AutoSizer
                            disableHeight={false}
                            disableWidth={false}
                            onResize={()=>null}
                            style={{ outline: 'none' }}
                        >
                            {({ height, width }) => (
                                <List
                                    width={width}
                                    height={height}
                                    ref={listRef}
                                    rowCount={filteredState.length}
                                    rowHeight={({ index }) => {
                                        return getAssayRowHeight(index, 900);
                                    }}
                                    rowRenderer={rowRenderer}
                                />
                            )}
                        </AutoSizer>
                    </div>)
                    : (<div className={classes.noAssays} style={{ background: takeId === 14 ? '#FFC100' : '#0077c85e',}}>
                        <div className={classes.listItemGroupTitle}>
                            <p>Чомусь у Вашому кошику ще нічого немає <span role="img" aria-label="Emoji.">🧐</span>.</p>
                        </div>
                    </div>)}
                <div className={classes.bottomContainer}>
                    <Button
                        variant="outlined"
                        color="primary"
                        className={classes.buttonConfirmOrder}
                        disabled={orderingList.length < 1}
                        onClick={handleSendOrdering}
                    >
                        замовити
                    </Button>
                    <Button
                        variant="outlined"
                        className={classes.redButton}
                        color="inherit"
                        onClick={(event) => handleGoBack(event)}
                    >
                        Продовжити вибір
                    </Button>
                </div>
            </div>
        </div>
        : <div className={classes.loading}><Loading/></div>);
};

export default ConfirmOrder;
